import type { CommandProject, CommandSession } from "@/types/command-agent";

/**
 * Resolve which Command agent owns a project context.
 * Prefers explicit `project.agent_id`, then the most recently updated session in the project.
 */
export function resolveProjectAgentId(
    projectId: string | null | undefined,
    projects: Array<Pick<CommandProject, "id" | "agent_id">>,
    sessions: Array<Pick<CommandSession, "project_id" | "agent_id" | "updated_at">>
): string | null {
    if (!projectId) return null;

    const project = projects.find((item) => item.id === projectId);
    if (project?.agent_id) return project.agent_id;

    const projectSessions = sessions.filter(
        (session) => session.project_id === projectId && session.agent_id
    );
    if (projectSessions.length === 0) return null;

    const sorted = [...projectSessions].sort(
        (a, b) => Date.parse(b.updated_at) - Date.parse(a.updated_at)
    );
    return sorted[0]?.agent_id ?? null;
}

/** Agent to use for chat while a project landing / draft project is active. */
export function resolveChatAgentId(options: {
    urlAgentId: string | null | undefined;
    draftProjectId: string | null | undefined;
    projects: Array<Pick<CommandProject, "id" | "agent_id">>;
    sessions: Array<Pick<CommandSession, "project_id" | "agent_id" | "updated_at">>;
}): string | null {
    const { urlAgentId, draftProjectId, projects, sessions } = options;
    if (!draftProjectId) return urlAgentId ?? null;
    return resolveProjectAgentId(draftProjectId, projects, sessions) ?? urlAgentId ?? null;
}
